<svg class="empty-icon"
     xmlns="http://www.w3.org/2000/svg" id="empty-icon"
     version="1.1"
     x="0px"
     y="0px"
     viewBox="0 0 299.125 215.15625">
    <metadata id="metadata7">
    </metadata>
    <g id="layer1" transform="translate(-141.53125,-622.6875)" fill="transparent">
        <path class="empty-icon-folder"
              d="m 144.18533,669.85149 c 0,-15.03861 3.95956,-22.55494 21.82289,-22.55494 l 126.81031,0 21.96139,-21.96139 93.46451,0 c 24.20724,0 29.76329,13.72087 29.76329,30.81189 l 0,144.95177 c 0,27.98181 -7.40657,34.08962 -29.96114,34.08962 l -241.30631,0 c -18.80344,0 -22.55494,-11.54612 -22.55494,-33.1861 z"
              id="path3757" stroke="currentColor"/>
        <path class="empty-icon-separator" d="m 142.84796,678.71664 147.35895,0 24.0586,24.29945 124.05218,0"
              id="path3763" stroke="currentColor"/>
        <g id="g3851" transform="matrix(0.73919072,0,0,0.73919072,75.920677,198.9461)">
            <g transform="matrix(2.3245445,0,0,2.3245445,-375.0843,-963.87561)" id="g3837">
                <path class="empty-icon-face empty-icon-eye"
                      d="m 242.19336,751.42244 c -6.11395,-1.18843 -10.10686,-7.10817 -8.91843,-13.22211 1.18843,-6.11394 7.10817,-10.10686 13.22211,-8.91843 6.11394,1.18843 10.10686,7.10817 8.91843,13.22212 -1.03012,5.29951 -5.67157,9.12562 -11.07027,9.12562"
                      id="path3773"
                      fill="currentColor"
                      transform="matrix(0.42514055,0,0,0.42514055,198.34322,415.48316)"/>
                <path class="empty-icon-face empty-icon-eye"
                      fill="currentColor"
                      transform="matrix(0.42514055,0,0,0.42514055,167.06575,415.48316)"
                      id="path3775"
                      d="m 242.19336,751.42244 c -6.11395,-1.18843 -10.10686,-7.10817 -8.91843,-13.22211 1.18843,-6.11394 7.10817,-10.10686 13.22211,-8.91843 6.11394,1.18843 10.10686,7.10817 8.91843,13.22212 -1.03012,5.29951 -5.67157,9.12562 -11.07027,9.12562"
                />
            </g>
            <path fill="currentColor" id="path3792" class="empty-icon-face empty-icon-mouth"
                  d="m 290.61533,773.88698 c -15.53523,0.22223 -29.89422,11.39499 -38.71389,29.27364 l 8.66174,0 c 7.6176,-12.03905 18.4782,-19.33435 30.11424,-19.50074 2.75435,-0.0393 5.54202,0.33376 8.35125,1.12592 9.05296,2.55272 16.81348,9.22046 22.6012,18.37482 l 8.66174,0 c -6.91357,-14.03125 -17.37039,-24.41787 -29.95903,-27.96757 -3.26473,-0.92059 -6.5163,-1.35184 -9.71725,-1.30607 z"/>
        </g>
    </g>
</svg>
